import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

export const TrackingMap = {
  visit_ted: TrackingEvent.actionCompleted(TrackingConstant.GET_STARTED, TrackingConstant.VISIT_TED),
  visit_srp: TrackingEvent.actionCompleted(TrackingConstant.GET_STARTED, TrackingConstant.VISIT_SRP),
};
